import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeLiff } from './services/liff';
import { initializeAnalytics } from './services/analytics';
import VConsole from 'vconsole';

if (import.meta.env.DEV || window.location.search.includes('debug=true')) {
  new VConsole();
}


// 環境変数からLIFF IDを取得（環境変数が設定されていない場合は本番用IDを使用）
const liffId = import.meta.env.VITE_REACT_APP_LIFF_ID || "2007240462-YK3n6zeO";

console.log(`Using LIFF ID: ${liffId} for environment: ${window.location.hostname}`);
console.log(`Environment variables loaded:`, {
  LIFF_ID: import.meta.env.VITE_REACT_APP_LIFF_ID,
  API_KEY: import.meta.env.VITE_API_KEY ? 'SET' : 'NOT SET',
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL
});

// 初期化を関数化して即時実行
const initApp = async () => {
  try {
    // LIFF初期化
    await initializeLiff(liffId);
    
    // Analytics初期化（並行実行）
    await initializeAnalytics();
  } catch (error) {
    console.error("Initialization failed", error);
  }

  // LIFFブラウザで起動していない場合（開発時など）でもアプリをレンダリング
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

// アプリ初期化を実行
initApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
